import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'lifedi-ranking-choice',
  templateUrl: './ranking-choice.component.html',
  styleUrls: ['./ranking-choice.component.scss']
})
export class RankingChoiceComponent implements OnInit {

  @Input() measureForm: FormGroup;
  @Input() ranking;
  @Input() isAutoNumber: boolean = true;
  @Input() questionNumber: number;
  @Input() type: string;
  @Input() font: string;
  @Output() progressVal = new EventEmitter<Number>();

  countProgress: number = 1;
  countAnswers: number = 0;

  rankingForm: FormGroup;
  answer = [];
  choices = [];
  done: boolean = false;

  constructor(
    private fb: FormBuilder,
  ) { }

  get answers(): FormArray {
    if (this.measureForm) {
      return this.measureForm.controls['DATA'] as FormArray;
    }
  }

  ngOnInit(): void {

    if (this.type === 'measure' || this.type === 'research') {
      this.rankingForm = this.fb.group({
        ID: [this.ranking.ID, Validators.required],
        ANSWER: this.fb.array([])
      });
      this.answers.push(this.rankingForm);
    }

    if (this.ranking) {
      this.ranking.VALUE[0].choices.forEach(e => {
        this.choices.push(e);

        if (this.type === 'measure') {
          (<FormArray>this.rankingForm.get("ANSWER")).push(this.fb.group({
            choice_id: ['', Validators.required],
            choice_detail: ['', Validators.required]
          }));
        } else if (this.type === 'research') {
          (<FormArray>this.rankingForm.get("ANSWER")).push(this.fb.group({
            choice_id: [''],
            choice_detail: ['']
          }));
        } else {
          this.done = true;
        }
      });

    }
  }

  get answerChoice(): FormArray {

    return this.rankingForm.get('ANSWER') as FormArray;
  }

  drop(event: CdkDragDrop<string[]>) {

    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }

    if (this.measureForm) {
      this.patchChoiceValue();
    }

  }

  patchChoiceValue() {
    let answerArr = [];
    this.answer.forEach(e => {
      answerArr.push(e);
    });

    this.answerChoice.patchValue(this.answer);
    this.answerChoice.updateValueAndValidity();

    if (answerArr.length < this.ranking.VALUE[0].choices.length) {
      for (let i = answerArr.length; i < this.ranking.VALUE[0].choices.length; i++) {
        const myForm = (<FormArray>this.answerChoice).at(i);
        myForm.patchValue({
          choice_id: '',
          choice_detail: ''
        });
      }
    }

    this.progress(this.answerChoice);
  }

  progress(form) {

    if (form.status === 'VALID') {
      this.done = true;
    } else if (form.status === 'INVALID') {
      this.done = false;
    }

    if (form.status === 'VALID' && this.countAnswers === 0) {
      this.countAnswers = 1;

      if (this.countAnswers === 1) {
        this.countProgress = 2;
        this.progressVal.emit(this.countProgress);
      }

    } else if (form.status === 'INVALID' && this.countProgress === 2) {
      this.countProgress = 0;
      this.countAnswers = 0;
      this.progressVal.emit(this.countProgress);
    }
  }

}
